import React from "react";
import { Box, Button, Typography, Card, CardContent } from "@mui/material";

const MatchCard = ({ match, onFileClaim, isMobile }) => {
  return (
    <Card
      sx={{
        position: "relative",
        width: "100%",
        backfaceVisibility: "hidden",
        borderRadius: "24px",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
        bgcolor: "#FFFFFF",
        border: "1px solid #E8F3E0",
      }}
    >
      <CardContent sx={{ p: 4 }}>
        <Typography 
          variant="h5" 
          sx={{ 
            color: "#2e4630",
            fontWeight: 600,
            fontSize: isMobile ? "20px" : "24px",
            mb: 1,
            fontFamily: "Poppins, Helvetica",
          }}
        >
          {match.item_name}
          <Typography
            component="span"
            sx={{
              color: "#516d4f",
              fontSize: isMobile ? "14px" : "16px",
              ml: 1,
              fontWeight: 500,
              bgcolor: "#E8F3E0",
              px: 2,
              py: 0.5,
              borderRadius: "12px",
              display: "inline-block"
            }}
          >
            {match.item_type}
          </Typography>
        </Typography>

        <Box 
          sx={{ 
            mt: 3,
            pt: 3,
            borderTop: "1px solid #E8F3E0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <Typography 
            sx={{ 
              color: "#516d4f",
              fontSize: "14px",
              fontWeight: 500
            }}
          >
            Match Score
          </Typography>
          <Box 
            sx={{ 
              bgcolor: "#E8F3E0",
              px: 2,
              py: 0.5,
              borderRadius: "12px",
              display: "flex",
              alignItems: "center"
            }}
          >
            <Typography
              sx={{
                color: "#2e4630",
                fontWeight: 600,
                fontSize: "14px"
              }}
            >
              {match.final_score.toFixed(1)}%
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mt: 4, textAlign: "center" }}>
          <Typography
            sx={{
              color: "#516d4f",
              fontSize: "14px",
              mb: 2,
              fontStyle: "italic"
            }}
          >
            Is this your item? File a claim to retrieve it
          </Typography>
          <Button
            variant="contained"
            onClick={onFileClaim}
            sx={{
              bgcolor: "#344b35",
              color: "#ffffff",
              fontWeight: 600,
              fontSize: "16px",
              py: 1.5,
              px: 4,
              borderRadius: "12px",
              textTransform: "none",
              fontFamily: "Poppins, Helvetica",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              '&:hover': {
                bgcolor: "#2a3c2a",
                boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.15)",
              }
            }}
          >
            File a Claim
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MatchCard;
